import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createSubjectGlobally } from "../../pages/services/notesService";
import "../../styles/CourseNotes.css";

const AddSubjectPage = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleSave = async () => {
    if (!title.trim()) { setError("Subject title is required."); return; }
    setSaving(true);
    setError("");
    try {
      await createSubjectGlobally(title.trim());
      navigate("/notes", { state: { successMessage: "Subject created successfully" } });
    } catch {
      setError("Failed to create subject. Please try again.");
    }
    setSaving(false);
  };

  return (
    <div className="cn-page">
      <div className="cn-header">
        <h2 className="cn-title">Add New Subject</h2>
        <button className="cn-back-btn" onClick={() => navigate("/notes")} disabled={saving}>
          ← Back
        </button>
      </div>

      <div className="cn-form-card" style={{ maxWidth: 560 }}>
        {error && <div className="cn-error">{error}</div>}

        <p style={{ fontSize: 13, color: "#6b7280", marginBottom: 16 }}>
          Subjects are global entities. After creating a subject, link it to courses from the Course edit screen.
        </p>

        <div className="cn-form-field">
          <label className="cn-form-label">Subject Title</label>
          <input
            className="cn-form-input"
            placeholder="e.g. Mathematics, Web Development…"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSave()}
          />
        </div>

        <div className="cn-form-actions">
          <button className="cn-cancel-btn-lg" onClick={() => navigate("/notes")} disabled={saving}>
            Cancel
          </button>
          <button className="cn-save-btn-lg" onClick={handleSave} disabled={saving}>
            {saving ? "Saving..." : "Create Subject"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddSubjectPage;
